module.exports = __webpack_public_path__ + "flyer_background_2019_tassle_108-9a8fde4d7e725b2a68b58646312aec4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_2019_tassle_108.jpg
// module id = 1595
// module chunks = 1